import { loginHrefWithReturn } from "../lib/returnAfterLogin";

/**
 * Обгортка над fetch для захищених /api/*: завжди шле куки (credentials),
 * а при простроченому access JWT (401) один раз викликає /api/auth/refresh і повторює запит —
 * аналогічно до client/src/api/axiosInterceptor.js для axios.
 */

let inFlightRefresh = null;

function refreshSession() {
    if (!inFlightRefresh) {
        inFlightRefresh = fetch("/api/auth/refresh", { credentials: "include" }).finally(() => {
            inFlightRefresh = null;
        });
    }
    return inFlightRefresh;
}

function redirectToLoginIfNeeded() {
    const path = window.location.pathname;
    const publicAuthPaths = ["/login", "/register"];
    if (!publicAuthPaths.includes(path)) {
        window.location.href = loginHrefWithReturn(window.location.pathname + window.location.search);
    }
}

export async function authFetch(input, init = {}) {
    const url = typeof input === "string" ? input : input instanceof Request ? input.url : "";

    const skipRefresh =
        typeof url === "string" &&
        (url.includes("/api/auth/login") ||
            url.includes("/api/auth/logout") ||
            url.includes("/api/auth/refresh"));

    const baseInit = { credentials: "include", ...init };

    let res = await fetch(input, baseInit);

    if (res.status !== 401 || skipRefresh) {
        return res;
    }

    try {
        const ref = await refreshSession();
        if (!ref.ok) {
            redirectToLoginIfNeeded();
            return res;
        }
        return await fetch(input, baseInit);
    } catch {
        redirectToLoginIfNeeded();
        return res;
    }
}
